import Banner from "../../components/banner";
import './home.css';
import { Link } from "react-router-dom";
import garageImage from '../../../assets/images/overzicht.png';
import { HomeIcon, PaintBrushIcon, ShoppingCartIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { ContentWrapper } from "../../utils/components";
import News from "../../components/news";
import Reviews from "../../components/reviews";

const HomePage = () => {

    const services = [
        {
            title: 'Garage',
            description: 'Onderhoud en herstellingen voor voertuigen van alle merken.',
            icon: <HomeIcon className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Carrosserie',
            description: 'Vakkundige herstellingen en lakwerken aan alle koetswerken.',
            icon: <PaintBrushIcon className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Verkoop',
            description: 'Aankoop en verkoop van betrouwbare tweedehandswagens.',
            icon: <ShoppingCartIcon className="w-12 h-12 text-[#3686c4]" />,
        },
        {
            title: 'Garantie',
            description: 'Altijd verzekerd van de beste service en kwaliteitsproducten.',
            icon: <ShieldCheckIcon className="w-12 h-12 text-[#3686c4]" />,
        },
    ];


    return (
        <div>
            <Banner />
            <section className="section intro-section">
                <div className="intro-content">
                    <div className="intro-text">
                        <h2>Welkom bij Auto&#8209;Service Thomas</h2>
                        <h4>Uw vertrouwde hersteller sinds 2014</h4>
                        <p>
                            Ontdek wie we zijn en wat we voor u kunnen betekenen. Maak kennis met onze diverse diensten en onze toewijding aan kwaliteit.
                            Bij ons vindt u steeds een actueel aanbod van betrouwbare tweedehandswagens met garantie.
                            We hopen dat uw bezoek aan onze website informatief is en kijken ernaar uit u binnenkort persoonlijk te verwelkomen in onze garage in Evergem.
                        </p>
                        <Link to="/over-ons" className="cta-button">Voorstelling →</Link>
                    </div>
                    <div className="intro-image">
                        <img src={garageImage} alt="Auto-Service Thomas" />
                    </div>
                </div>
            </section>
            <section className="section home-services-section">
                <ContentWrapper>
                    <h2 className="title">Onze diensten</h2>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div className="service-card" key={index}>
                                <div className="service-icon">{service.icon}</div>
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                            </div>
                        ))}
                    </div>
                </ContentWrapper>
            </section>
            <News />
            <Reviews />
        </div>
    );
}

export default HomePage;